import React from 'react';
import PropTypes from 'prop-types';

export default class AccordionItem extends React.Component {

  render() {
    return (
      <div className="panel">
        <div className="panel-heading" role="tab" id={'collapse-heading-' + this.props.id}>
          <h4 className="panel-title">
            <a
              role="button"
              data-toggle="collapse"
              data-parent={'#' + this.props.accordionId}
              href={'#collapse-' + this.props.id}
              aria-expanded="false"
              aria-controls={'collapse-' + this.props.id}
              className="collapsed">{this.props.title}</a>
          </h4>
        </div>
        <div
          id={'collapse-' + this.props.id}
          className={'panel-collapse collapse ' + ( this.props.expanded ? 'in' : '' )}
          role="tabpanel"
          aria-labelledby={'collapse-heading-' + this.props.id}
          aria-expanded="false"
          style={{height: 0}}
        >
          <div className={'panel-body'}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }

}

AccordionItem.propTypes = {
  id: PropTypes.string.isRequired,
  accordionId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  expanded: PropTypes.bool,
};

AccordionItem.defaultProps = {
  expanded: false,
};



// WEBPACK FOOTER //
// ./src/app/shared/components/accordion/AccordionItem.js